import React from 'react';
import {
  Button,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {Modal} from '../../../components/Modal/Modal';
import {ModalButtons} from '../../../components/Modal/layout';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';

type Props = {
  isOpen: boolean;
  close: () => void;
};

export function RecaptchaFailedModal({isOpen, close}: Props) {
  return (
    <Modal isOpen={isOpen} close={close}>
      <Title>Verification Failed</Title>
      <Content>Refresh the page and try again or use another browser.</Content>
      <ModalButtons>
        <Button color="secondary" width={ButtonWidth.WIDE} onClick={close}>
          Close
        </Button>
      </ModalButtons>
    </Modal>
  );
}
